import React from 'react';
import PropTypes from 'prop-types';
import style from './style.css';

const MenuItem = ({ children, onClick }) =>  {
  return (
    <li onClick={ onClick } className={ style.item }>
      { children }
    </li>
  );
};

MenuItem.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.instanceOf(PropTypes.element)),
  ]),
};

export default MenuItem;



// WEBPACK FOOTER //
// ./client/src/components/drop-down-menu/menu-item.js